import { Grid, Typography, ButtonBase } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import { useResponsive } from "../../Modulo_Responsive/Hooks/useResponsive";
import proyectosData from "../../Data/Proyectos.json";
import { Helmet } from "react-helmet";

const Seccion_Lista_Proyectos = () => {
    const { sCell } = useResponsive();

    return (
        <>
            <Helmet>
                {/* SEO básico */}
                <title>Proyectos de Remodelación | Espacio Compacto</title>
                <meta
                    name="description"
                    content="Explora nuestros proyectos de remodelación de cocinas, baños y closets en Cali. Diseños personalizados y funcionales con Espacio Compacto."
                />
                <meta name="keywords" content="remodelación, diseño de interiores, cocinas, baños, closets, muebles a medida, optimización de espacios, Cali" />

                {/* JSON-LD: CollectionPage */}
                <script type="application/ld+json">
                    {JSON.stringify({
                        "@context": "https://schema.org",
                        "@type": "CollectionPage",
                        "name": "Proyectos de Remodelación | Espacio Compacto",
                        "description": "Explora nuestros proyectos de remodelación de cocinas, baños y closets en Cali. Diseños personalizados y funcionales.",
                        "url": "https://espaciocompato.web.app/proyectos/"
                    })}
                </script>
            </Helmet>

            <Grid
                container
                justifyContent={"center"}
                alignItems={"center"}
                size={{ xs: 12, sm: 12, md: 12 }}
                component="section"
            >
                <Grid
                    container
                    justifyContent={"center"}
                    alignItems={"center"}
                    size={{ xs: 12, sm: 12, md: 10 }}
                    sx={{ maxWidth: "1400px", px: 3, pt: 14 }}
                >
                    <Grid
                        container
                        justifyContent={"flex-start"}
                        alignItems={"center"}
                        size={{ xs: 12, sm: 12, md: 12 }}
                        sx={{ p: 1.5 }}
                    >
                        <Typography
                            component="h2"
                            sx={{
                                fontSize: 24,
                                fontWeight: 700,
                                textAlign: "center",
                                color: "#223B59",
                            }}
                            itemProp="name"
                        >
                            Proyectos
                        </Typography>
                    </Grid>

                    <Grid
                        container
                        size={{ xs: 12, sm: 12, md: 12 }}
                        sx={{ mt: 0 }}
                        component="ul"
                        style={{ listStyle: "none", padding: 0, margin: 0 }}
                    >
                        {proyectosData.proyectos.map((proyecto) => (
                            <Grid
                                container
                                justifyContent={"flex-start"}
                                alignItems={"flex-start"}
                                size={{ xs: 12, sm: 4, md: 3 }}
                                key={proyecto.id}
                                sx={{ p: 1.5, pb:8 }}
                                component="li"
                                itemScope
                                itemType="https://schema.org/CreativeWork"
                            >
                                <ButtonBase
                                    component={RouterLink}
                                    to={`/proyectos/${proyecto.id}`}
                                    sx={{
                                        width: "100%",
                                        display: "block",
                                        textAlign: "left",
                                    }}
                                    aria-label={`Ver detalles del proyecto ${proyecto.titulo} en ${proyecto.lugar}`}
                                    itemProp="url"
                                >
                                    <img
                                        src={proyecto.portada}
                                        alt={`Proyecto en ${proyecto.lugar}: ${proyecto.titulo}`}
                                        style={{
                                            width: "100%",
                                            height: "auto",
                                            borderRadius: "0px",
                                            display: "block",
                                        }}
                                        loading="lazy"
                                        itemProp="image"
                                    />
                                    <Typography
                                        component="p"
                                        sx={{
                                            fontSize: 16,
                                            fontWeight: 500,
                                            color: "#223B59",
                                            textAlign: "left",
                                            mt: 1.5,
                                            mb: 0,
                                            lineHeight: 1.3,
                                            display: "block",
                                        }}
                                        itemProp="about"
                                    >
                                        {proyecto.lugar}
                                    </Typography>
                                </ButtonBase>
                            </Grid>
                        ))}
                    </Grid>
                </Grid>
            </Grid>
        </>
    );
};

export default Seccion_Lista_Proyectos;
